<template>
	<v-autocomplete
		dense
		outlined
		class="slct set"
		item-text="title"
		persistent-hint
		item-value="value"
		:items="timezonesArr"
		v-model="localUserTimeZone"
		placeholder="Select timezone"
		append-icon="fa fa-chevron-down"
		:search-input.sync="searchString"
		:hint="`suggested timezone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`"
	/>
</template>

<script>
import moment from 'moment-timezone';
export default {
	name: 'SelectTimezone',
	props: { userTimezone: { type: String } },
	computed: {
		timezonesArr() {
			return moment.tz.names();
		},
		localUserTimeZone: {
			get() {
				return this.userTimezone;
			},
			set(value) {
				if (value) {
					this.$emit('update:userTimezone', value);
				}
			},
		},
	},
	data: () => ({
		searchString: '',
	}),
};
</script>
